import { MarketInfo } from '@cex/shared-modules';

export const DEFAULT_PRICE_SCALE = 2;

export const getPriceScale = (market) => {
  return market?.priceScale || DEFAULT_PRICE_SCALE;
};

export const getTradingviewSymbol = (market: MarketInfo | undefined): string => {
  if (market) {
    const { id } = market;
    const transformed = id.replace('-', '');
    return transformed.toUpperCase();
  }
  return '';
};

export const defaultMissingValue = '__.__';
